/*
 *
 *  Deferred Boolean
 *
 *  A Boolean only Deferred state.
 */
import DeferredState from '../../lib/util/DeferredState.js';

function DeferredBoolean(initialState) {
    if (typeof initialState !== 'undefined') {
        this.set(initialState);
    }
}
DeferredBoolean.prototype = new DeferredState(['yes', 'no']);
DeferredBoolean.prototype._set = DeferredBoolean.prototype.set;
DeferredBoolean.prototype.set = function (value) {
    return this._set(value ? 'yes' : 'no');
};
DeferredBoolean.prototype.get = function (value) {
    return this.state == 'yes';
};
DeferredBoolean.prototype.then = DeferredBoolean.prototype.yes;
DeferredBoolean.prototype.otherwise = DeferredBoolean.prototype.no;

export default DeferredBoolean;
